import styled from '@emotion/styled';
import React from 'react';

const DescriptionText = styled.p`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 0.96rem;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1e4e66;
    margin: 0;
`;

const ChecklistContainer = styled.div`
    border-radius: 12px;
    background: #dfecf3;
    padding: 20px;
    margin: 20px 0;
`;

const ChecklistText = styled.div`
    color: #1e4e66;
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 220%;
    letter-spacing: 0.8px;
    white-space: pre-line;
`;

export const MaForBeginnerDerail_3_3: React.FC = () => {
    return (
        <>
            <DescriptionText>M&A仲介会社と初めて面談する際には、以下の10点を確認しておきましょう。</DescriptionText>
            <ChecklistContainer>
                <ChecklistText>
                    {`1. 手数料について（着手金・中間金・成功報酬の有無と水準）
2. 契約形態について（専任契約か、複数併用できる非専任契約か）
3. 買い手候補の探し方について（ネットワークや独自データベースの有無）
4. 成約までの期間について（平均的な期間と見込み）
5. 担当者の能力について（過去の実績や担当件数）
6. 契約解除時の解約料等について（違約金の有無や条件）
7. 株価評価方法について（DCF法、類似会社比準法など評価基準）
8. 秘密保持体制について（情報管理の仕組みや体制）
9. 税務・法務サポートについて（専門家との連携体制）
10. 希望スケジュールについて（譲渡完了までの柔軟な対応可否）`}
                </ChecklistText>
            </ChecklistContainer>
            <DescriptionText>
                これらを事前に確認することで、後のトラブルを防ぎ、安心してM&Aをめられます。
            </DescriptionText>
        </>
    );
};
